import React, { useState } from 'react';
import TextFieldNumber from '../../../../components/TextFieldNumber';
import { useGhgOrganization, useLanguage } from 'src/common/hooks';
import { Overlay } from '../Title/index.styles';
import { Form, FormBox } from './index.styles';
import { AutocompleteFreesolo, Select } from '../fields';
import {
  type_of_vehicle,
  unit_of_distance,
  vehicle_names_en,
  vehicle_names_pl,
} from './data';
import FormButtons from '../FormButtons';
import { autoCompleteOptions } from '../../../../utils/helpers';

export default function EvDistanceForm({
  state,
  setState,
  id,
  active,
  setActive,
  commitState,
}: {
  state: any;
  setState: Function;
  id: number;
  active: undefined | number;
  setActive: Function;
  commitState: (state: any[]) => void;
}) {
  const { t, language } = useLanguage();

  let type_of_vehicle_error = false;
  let unit_of_distance_error = false;
  let distance_travelled_error = false;
  let manual_factor_error = false;

  const [type_of_vehicle_error_state, set_type_of_vehicle_error_state] =
    useState(false);
  const [unit_of_distance_error_state, set_unit_of_distance_error_state] =
    useState(false);
  const [distance_travelled_error_state, set_distance_travelled_error_state] =
    useState(false);
  const [manual_factor_error_state, set_manual_factor_error_state] =
    useState(false);

  const type_of_vehicle_validation = (value: string) => {
    if (value === '') type_of_vehicle_error = true;
    return type_of_vehicle_error;
  };
  const unit_of_distance_validation = (value: string) => {
    if (value === '') unit_of_distance_error = true;
    return unit_of_distance_error;
  };
  const distance_travelled_validation = (value: string) => {
    if (value === '') distance_travelled_error = true;
    return distance_travelled_error;
  };
  const manual_factor_validation = (value: string) => {
    if (value === '') manual_factor_error = true;
    return manual_factor_error;
  };

  const handleTypeOfVehicleLabel = (value: string) => {
    const newForms = [...state];
    let commutingType = newForms[id];

    commutingType = {
      ...commutingType,
      type_of_vehicle_label: value,
    };
    newForms[id] = commutingType;
    setState(newForms);
  };

  const setTypeOfVehicle = (value: string) => {
    type_of_vehicle_validation(value);
    set_type_of_vehicle_error_state(false);
    const newForms = [...state];
    let commutingType = newForms[id];

    commutingType = {
      ...commutingType,
      type_of_vehicle: value,
    };
    newForms[id] = commutingType;
    setState(newForms);
    if (value === '') set_type_of_vehicle_error_state(true);
  };
  const setUnitOfDistance = (value: string) => {
    unit_of_distance_validation(value);
    set_unit_of_distance_error_state(false);
    const newForms = [...state];
    let commutingType = newForms[id];

    commutingType = {
      ...commutingType,
      unit_of_distance: value,
    };
    newForms[id] = commutingType;
    setState(newForms);
    if (value === '') set_unit_of_distance_error_state(true);
  };
  const handleDistance = (value: string) => {
    distance_travelled_validation(value);
    set_distance_travelled_error_state(false);
    const newForms = [...state];
    let commutingType = newForms[id];

    commutingType = {
      ...commutingType,
      distance_travelled: value,
    };
    newForms[id] = commutingType;
    setState(newForms);
    if (value === '') set_distance_travelled_error_state(true);
  };
  const handleFactor = (value: string) => {
    manual_factor_validation(value);
    set_manual_factor_error_state(false);
    const newForms = [...state];
    let commutingType = newForms[id];

    commutingType = {
      ...commutingType,
      manual_factor: value,
    };
    newForms[id] = commutingType;
    setState(newForms);
    if (value === '' && newForms[id].type_of_vehicle === 'other.manual_factor')
      set_manual_factor_error_state(true);
  };

  const handleSend = (data: any) => {
    if (
      !type_of_vehicle_error &&
      !unit_of_distance_error &&
      !distance_travelled_error &&
      !manual_factor_error
    ) {
      commitState(data);
    }
  };

  const defineErrors = async () => {
    if (state[id].type_of_vehicle === '') {
      set_type_of_vehicle_error_state(true);
      type_of_vehicle_error = true;
    }
    if (state[id].unit_of_distance === '') {
      set_unit_of_distance_error_state(true);
      unit_of_distance_error = true;
    }
    if (state[id].distance_travelled === '') {
      set_distance_travelled_error_state(true);
      distance_travelled_error = true;
    }

    if (
      state[id].type_of_vehicle === 'other.manual_factor' &&
      !state[id].manual_factor
    ) {
      set_manual_factor_error_state(true);
      manual_factor_error = true;
    }
  };

  const handleRemove = async () => {
    const tempState = [...state];
    tempState.splice(id, 1);
    setState(tempState);
    commitState(tempState);
  };

  return (
    <>
      {active === id && <Overlay onClick={() => setActive(undefined)} />}
      <Form active={active === id}>
        <div onClick={() => setActive(id)}>
          <FormBox variant="50">
            <AutocompleteFreesolo
              active
              error={false}
              index={1}
              label={t(
                `electricity-emission.vehicles.distance.type_of_vehicle_label`
              )}
              value={state[id].type_of_vehicle_label}
              setValue={(value: string) =>
                handleTypeOfVehicleLabel(autoCompleteOptions(value))
              }
              max={123}
              options={[]}
            />
          </FormBox>

          <FormBox variant="50">
            <Select
              active
              index={1}
              max={12}
              options={type_of_vehicle}
              label={t(
                `electricity-emission.vehicles.distance.type_of_vehicle`
              )}
              error={type_of_vehicle_error_state}
              value={state[id].type_of_vehicle}
              setValue={(e: string) => setTypeOfVehicle(e)}
            />
          </FormBox>

          <FormBox variant="50">
            <TextFieldNumber
              label={t(
                `electricity-emission.vehicles.distance.distance_travelled`
              )}
              active
              error={distance_travelled_error_state}
              index={1}
              value={state[id].distance_travelled}
              setValue={(e: string) => handleDistance(e)}
            />
          </FormBox>

          <FormBox variant="50">
            <Select
              active
              index={1}
              max={12}
              options={unit_of_distance}
              label={t(
                `electricity-emission.vehicles.distance.unit_of_distance`
              )}
              error={unit_of_distance_error_state}
              value={state[id].unit_of_distance}
              setValue={(e: string) => setUnitOfDistance(e)}
            />
          </FormBox>

          {state[id].type_of_vehicle === 'other.manual_factor' && (
            <FormBox variant="100">
              <TextFieldNumber
                type="factor"
                label={t(
                  `electricity-emission.vehicles.distance.manual_factor`
                )}
                active
                error={manual_factor_error_state}
                index={1}
                value={state[id].manual_factor}
                setValue={(e: string) => handleFactor(e)}
              />
            </FormBox>
          )}
        </div>

        {active === id && (
          <FormButtons
            canCopy={
              state[id].distance_travelled !== '' &&
              state[id].type_of_vehicle !== '' &&
              state[id].unit_of_distance !== '' &&
              (state[id].type_of_vehicle !== 'other.manual_factor' ||
                !!state[id].manual_factor)
            }
            setActive={setActive}
            state={state}
            setState={setState}
            id={id}
            onClickRemove={() => handleRemove()}
            onClickAccept={() =>
              defineErrors().then(() => {
                handleSend(state);
              })
            }
          />
        )}
      </Form>
    </>
  );
}
